import * as React from 'react';
import { createRoot } from 'react-dom/client';

import Box from '@mui/material/Box';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Bs4ViewDateTime from '../Bs4Components/Bs4ViewDateTimeColumn'
import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import Bs4MainDispatch from '../Bs4MainDispatch'

function getValue(value) {
  //Na wszelki wypadek, v może być null, object, ...        
  value = String(value || '');

  const dv = value.split(' ')[0];
  // console.log('...???...column DT', dv, value);
  if(!value || dv == "0001-01-01" || dv == "0000-00-00" || value?.startsWith('-') || value?.startsWith('0000')) {
    return ''; 
  }                        

  //Czy v zawiera inne znaki niż cyfrt (0-9) 
  if((value.match(/[^0-9]/g) || []).length > 0) {
    // tak - prawdopodobnie iso format
    return Bs4Utils.toDateTime(value)
  }else {             
    // nie - prawdopodobnie unix format 
    return Bs4Utils.toDateTime(new Date(1000 * parseInt(value)))
  }    
}

export const formatterDateTime = (cell, formatterParams, onRendered) => {
	return getValue(cell.getValue());
}

export function editorDateTime(cell, onRendered, success, cancel, editorParams){
  const editor = document.createElement("div");  
  const styleBorder = cell.getElement().style.border
  cell.getElement().style.border = 'none';

  const root = createRoot(editor);

  const bs4Success = (value) => {
    cell.getElement().style.border = styleBorder;
    try {
      root.unmount()
    } catch (error) {
      console.log('unmout error', error)
    }    
    if (getValue(cell.getValue()) === getValue(value)) cancel();
    // console.log('...Bs4ColumnsTime...success...', value);  
    success(value);
  }

  onRendered(() => {
    root.render(
      <ViewComponentDateTime
        value={getValue(cell.getValue())} 
        editorParams={editorParams}
        bs4Success={bs4Success}
        cancel={cancel}
        cell={cell}
      />);      
  });
  
  return editor;
}

const ViewComponentDateTime = (props) => {
  const [value, setValue] = React.useState(Bs4Utils.getValidDate(getValue(props.value)));
  const inputRef = React.useRef();
  const valueRef = React.useRef(value);

  const onchange = (newValue) => {    
    valueRef.current = newValue;
    setValue(newValue);
    // console.log('...Bs4ColumnsTime...change...', newValue, valueRef.current);  
  }

  const bs4Success = (value) => {
    const valueStr = Bs4Utils.toDateTime(value)
    props.bs4Success(valueStr);
  }

  const handLeleaveField = () => {
    // console.log('...Bs4ColumnsDateTime...LeleaveField...', value, valueRef.current);  
    bs4Success(valueRef.current);
  }

  const onKeyDownTextField = (e) => {
    // console.log('...Bs4ColumnsTime...Key...', e);  
    switch (e.keyCode) {
      case 13: //Enter
        bs4Success(valueRef.current);
        break;

      case 9: //Tab
        break;

      case 27:  //Esc
        props.cancel();
        break;

      case 38: //up arrow
      case 40: //down arrow
        // if (props?.editorParams?.verticalNavigation == "editor") {
        //   if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        //   e.stopPropagation();
        // }
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.stopPropagation();
        // if (e.preventDefault) e.preventDefault()
        break;

      case 35:
      case 36:
        e.stopPropagation();
        break;
    }
  }

  React.useEffect(() => {
    if (props.cell?.getRow()) props.cell.getRow().normalizeHeight()
  }, [props.cell]);

  React.useEffect(() => {
    inputRef.current?.focus();
    // console.log('...Bs4ColumnsDateTime...inputRef.current?.focus()...');
  }, [inputRef.current]);

  const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={xx}
      localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box overflow={'hidden'}>
        <Bs4ViewDateTime
          inputRef={inputRef}
          value={value}
          fullWidth
          onChange={(newValue) => onchange(newValue)}
          onLeaveField={handLeleaveField}
          hoursMin={props.editorParams?.hours_min}
          hoursMax={props.editorParams?.hours_max}
          timeStep={parseInt(props.editorParams?.min_interval) || 5} 
          slotProps={{
            textField: {
              autoFocus: true,
              margin: 'dense',
              size: 'small',              
              variant: "outlined",
              sx: { mt: '2px', mb: '1px', my: '1px', '& input': { padding: 0.5 } },
              onKeyDown: onKeyDownTextField,              
            }
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}